import Footer from "../../components/Footer"
import Header from "../../components/Header"
import styles from "./styles.module.css"
import { useNavigate } from "react-router-dom"

function Layout({children}) {
    const navigate = useNavigate()
    return(
        <>
            <Header onLogoClick={() => navigate("/")}/>
            <main className={styles.pageContainer}>
                {children}
            </main>
            <Footer />
        </>
    )
}

export default Layout